'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
import { textColorValues } from "../../atomic/colors.css.js";
const hasContrast = (a, b) => tinycolor.isReadable(a, b, { level: "AA", size: "small" });
const getForegroundColor = (backgroundColor, foregroundColor, alternativeForegroundColor) => {
  if (hasContrast(backgroundColor, foregroundColor)) {
    return foregroundColor;
  }
  if (alternativeForegroundColor && hasContrast(backgroundColor, alternativeForegroundColor)) {
    return alternativeForegroundColor;
  }
  if (hasContrast(backgroundColor, textColorValues["onLight.text.primary"])) {
    return textColorValues["onLight.text.primary"];
  }
  if (hasContrast(backgroundColor, textColorValues["onDark.text.primary"])) {
    return textColorValues["onDark.text.primary"];
  }
  return tinycolor.mostReadable(backgroundColor, [
    textColorValues["onLight.text.primary"],
    textColorValues["onDark.text.primary"]
  ]).toHexString();
};
const getThemedColor = (color) => {
  if (tinycolor(color).isValid()) {
    const lightest = tinycolor(color).lighten(50.2).toHexString();
    const light = tinycolor(color).lighten(48).toHexString();
    const base = tinycolor(color).lighten(37).toHexString();
    const dark = tinycolor(color).toHexString();
    const darkest = tinycolor(color).darken(11).toHexString();
    return {
      primary: {
        background: {
          lightest,
          light,
          base,
          dark,
          darkest
        },
        foreground: {
          lightest: getForegroundColor(lightest, dark, darkest),
          light: getForegroundColor(light, darkest),
          base: getForegroundColor(base, darkest, lightest),
          dark: getForegroundColor(dark, lightest),
          darkest: getForegroundColor(darkest, light, lightest)
        }
      }
    };
  }
  return void 0;
};
export {
  getThemedColor
};
